/**
 * Created by @author Søren Tramm on 15/08/2023.
 */
export const textQuestionConfig = [
  {
    id: 'min',
    type: 'NUMBER',
    placeholder: 'Minimum character length',
    label: 'Minimum',
    postfix: '',
    value: '',
    validation: { required: false },
    errorMsg: '',
  },
  {
    id: 'max',
    type: 'NUMBER',
    placeholder: 'Maximum character length',
    label: 'Maximum',
    postfix: '',
    value: '',
    validation: { required: false },
    errorMsg: '',
  },
] as const
